/**
 * The greeting's time band.
 *
 * Read from the account's own clock rather than UTC: a user in Los Angeles
 * opening Home at 9am must not be told "Good evening" because the server's
 * day is further along. The hour is passed in so the caller decides which
 * clock that is, and so the boundaries are testable without faking time.
 */
export type GreetingBand = "morning" | "afternoon" | "evening"

/** 05:00 and noon and 18:00 are the boundaries; 18:00–04:59 reads as evening. */
export const greetingBandForHour = (hour: number): GreetingBand => {
  if (hour >= 18 || hour < 5) return "evening"
  if (hour >= 12) return "afternoon"
  return "morning"
}

export const GREETING_DEFAULTS: Record<GreetingBand, string> = {
  morning: "Good morning",
  afternoon: "Good afternoon",
  evening: "Good evening"
}
